import React, { useContext, useState } from "react";
import { AppContext } from "../../Context/Provider";

const inputClass =
  "w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-gray-900";

const ChangePassword = () => {
  const { ChangeCurrentPassword } = useContext(AppContext);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    const result = await ChangeCurrentPassword({
      oldPassword,
      password,
      confirmPassword,
    });
    setLoading(false);
    if (result?.success) window.location.href = "/Sidebar/dashboard";
  };

  return (
    <section className="flex min-h-screen items-center justify-center bg-gray-50 px-6">
      <div className="w-full max-w-md space-y-4 rounded-lg bg-white p-8 shadow">
        <h1 className="text-2xl font-bold">Change your password</h1>
        <p className="text-sm text-gray-600">
          You must choose a new password before continuing.
        </p>
        <input type="password" className={inputClass} placeholder="Current password" value={oldPassword} onChange={(event) => setOldPassword(event.target.value)} />
        <input type="password" className={inputClass} placeholder="New password" value={password} onChange={(event) => setPassword(event.target.value)} />
        <input type="password" className={inputClass} placeholder="Confirm new password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} />
        <button type="button" disabled={loading} onClick={submit} className="w-full rounded-lg bg-custom-green px-5 py-2.5 text-white disabled:opacity-60">
          {loading ? "Please wait..." : "Change password"}
        </button>
      </div>
    </section>
  );
};

export default ChangePassword;
